import React from 'react';
import { Link } from 'react-router-dom';
import { APP_FULL_NAME, ROUTES } from '../../utils/constants';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{APP_FULL_NAME}</h4>
            <p>
              Building community and sharing knowledge in the intersection of 
              LGBTQ+ identity and data/tech work.
            </p>
          </div>

          <div className="footer-section">
            <h4>Community</h4>
            <ul className="footer-links">
              <li><Link to={ROUTES.CONTENT}>Resource Library</Link></li>
              <li><Link to={ROUTES.COMMUNITY}>Community Board</Link></li>
              <li><Link to={ROUTES.SUPPORT}>Support QDN</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <ul className="footer-links">
              <li><a href="https://discord.gg/Zg6m3gBx" target="_blank" rel="noreferrer">Discord</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Resources</h4>
            <ul className="footer-links">
              <li><Link to={ROUTES.ABOUT}>About QDN</Link></li>
              <li><Link to={ROUTES.GETTING_STARTED}>Getting Started</Link></li>
              <li><Link to={ROUTES.CODE_OF_CONDUCT}>Code of Conduct</Link></li>
              <li><Link to={ROUTES.PRIVACY_POLICY}>Privacy Policy</Link></li>
              <li><Link to={ROUTES.TERMS_OF_SERVICE}>Terms of Service</Link></li>
              <li><Link to={ROUTES.CONTACT}>Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {APP_FULL_NAME}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;